import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';


export class ZjInstitutionInforApi extends SystemBaseApi {

    public get ControllerName(): any {
        return 'zj-institutioninfor'
    }

    public getEntitiesPage(current,size,param) {
        return this.send(param, "getEntitiesPage?current="+current+"&size="+size, Methods.GET)
    }

    public getChildList(institutionId){
        return this.send({institutionId:institutionId},"getChildList",Methods.GET)
    }

    public getListByProjectDataId(projectDataId){
        return this.send({projectDataId:projectDataId},"getListByProjectDataId",Methods.GET)
    }
}
